<template>
  <div id="app">
   <router-view/>
   <Footer></Footer>
  </div>
</template>
<script>
import Footer from './components/Footer.vue'
export default {
  name: 'app',
  components: {
    Footer
  },
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
@media (min-width: 1200px) {
body {
  min-height: 40rem;
  padding-top: 6.2rem;
}
}
@media (min-width: 300px) and (max-width: 700px) {
  body {
  min-height: 40rem;
  padding-top: 4rem;
}
}
@media (min-width: 701px) and (max-width: 1199px) {
  body {
  min-height: 40rem;
  padding-top: 5.4rem;
}
}
</style>